import { Breakpoints } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

import { PanelActions } from './panel.actions';
import { RootState } from '../root-state.model';

@Injectable()
export class PanelEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);

  toggleViewerState$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(PanelActions.ToggleViewerState),
      withLatestFrom(this.store),
      map(([action, store]) => {
        const isSmall =
          store.app.breakPointState.breakpoints[Breakpoints.Small] || store.app.breakPointState.breakpoints[Breakpoints.XSmall];

        if (isSmall) {
          return PanelActions.SetCalculatedViewerState({ state: [action.panel] });
        } else {
          const panels = store.panel.activePanelViews;
          const isOpen = panels.includes(action.panel);

          if (isOpen && panels.length === 1) {
            return PanelActions.SetCalculatedViewerState({ state: panels });
          }

          return PanelActions.SetCalculatedViewerState({
            state: isOpen ? panels.filter((s) => s !== action.panel) : [...panels, action.panel],
          });
        }
      }),
    ),
  );
}
